// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('contacts.companies', {
        url: '/companies?searchTerm',
        views: {
            "contactList@contacts": {
                templateUrl: 'main/contacts/companies/companies.tpl.html',
                controller: 'ContactsCompaniesController as vm'
            }
        },
        resolve: {
            companies: companiesResolver,
            searchTerm: searchTermesolver
        }
    });
}

// @ngInject
function companiesResolver(CompaniesApiService,$stateParams) {
    return CompaniesApiService.listAll({ filter: $stateParams.searchTerm});
}
// @ngInject
function searchTermesolver($stateParams) {
    return $stateParams.searchTerm;
}

// @ngInject
function ContactsCompaniesController($rootScope, $state, $scope, AuthService, companies, CompaniesApiService, loadSpinnerService, searchTerm) {
    var vm = this;

    vm.currentUser = $rootScope.currentUser;

    vm.companies = companies;
    vm.selectedCompanyId = 0;
    vm.searchTerm =  (searchTerm) ? searchTerm : '';

    vm.searchTermChange = searchTermChange;
    vm.goToCompany = goToCompany;

    activate();

    function activate() {
        $scope.$watch(function() { return $state.params.brandId; }, function(newValue, oldValue) {
            vm.selectedCompanyId = parseInt($state.params.companyId, 10);
        });
        $rootScope.$on('Company.Changed', function() {
            reload();
        });
    }

    function searchTermChange() {
        reload();
    }

    function reload() {
        loadSpinnerService.start('mainSpinner');
        CompaniesApiService.listAll({ filter: vm.searchTerm}).then(function (data) {
            vm.companies = data;
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner', { force: true });
        });
    }

    function goToCompany(company) {
        if (AuthService.canAccess('company', 'read')) {
            vm.selectedCompanyId = company.id;
            $state.go('contacts.companies.company', {companyId: company.id});
        }
    }
}

angular.module('contacts.companies', ['companies.api','companies.company'])
    .config(stateConfig)
    .controller('ContactsCompaniesController', ContactsCompaniesController);
